import { render, staticRenderFns } from "./Pillar.vue?vue&type=template&id=5a8ddd3c&scoped=true&"
import script from "./Pillar.vue?vue&type=script&lang=js&"
export * from "./Pillar.vue?vue&type=script&lang=js&"
import style0 from "./Pillar.vue?vue&type=style&index=0&id=5a8ddd3c&lang=scss&scoped=true&"
import style1 from "./Pillar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ddd3c",
  null
  
)

export default component.exports